import { render, staticRenderFns } from "./user.vue?vue&type=template&id=0704f0d6&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&id=0704f0d6&scoped=true&lang=css&"
import style1 from "./user.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704f0d6",
  null
  
)

export default component.exports